<template>
	<div class="container-fluid pX-15">
		<div class="row container-topbar pT-10" v-if="$slots.topBarLeft || $slots.topBarRight">
            <div class="pX-0" :class="topBarLeftClass" v-if="$slots.topBarLeft">
                <slot name="topBarLeft"></slot>
            </div>
            <div class="ta-l pL-5 pR-5 ta-r" :class="topBarRightClass" v-if="$slots.topBarRight">
            	<span class="pull-right" style="width: 70px; height: 1px;" v-if="!hideTabelSetting"></span>
                
                <slot name="topBarRight"></slot>
            </div>
        </div>
        <div class="container-main-wrap pT-10">
        	<slot name="main"></slot>
        </div>
        <slot></slot>
	</div>
</template>

<script>
    export default {
        name: '',
        props: {
            topBarLeftClass: {
                type: String,
                default: 'col-md-4'
            },
            topBarRightClass: {
                type: String,
                default: 'col-md-8'
            },
            hideTabelSetting: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss">
.container-topbar {
    min-height:42px;
    background: #ffffff;
    margin-left: -20px;
    padding-left: 5px;
}
.container-main-wrap {
}
</style>



// WEBPACK FOOTER //
// src/components/container/container.vue